<div class="iguau-profile-hero position-relative" id="perfil{{perfil.ID}}" 
    *ngIf="perfil && (perfil | keyvalue)?.length" 
    [class.blur-strong]="misdatos.perfilPublico == 'no_publico' && misdatos.ID != perfil.ID"
    [ngStyle]="{
      'background-image': 'linear-gradient(90deg, rgba(250, 249, 245, 0.76) 0%, rgba(250, 249, 245, 0.63) 42%, rgba(250, 249, 245, 0.36) 100%), url(' + (perfil?.foto?.foto_principal_grande || '') + ')',
      'background-size': 'cover',
      'background-position': 'center'
    }">
  <div class="iguau-hero-content">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-4 col-md-3 col-lg-3 col-xl-3 div-delete iguau-avatar-area">
            <img
              *ngIf="!editando && perfil?.foto?.foto_principal_thumb"
              [src]="perfil?.foto?.foto_principal_thumb || global.urlServer + 'img/default-user.png'"
              class="rounded-circle pointer div-shadow thumb-popup"
              [class.borde-blanco]="perfil.losigo == ''"
              [class.borde-iguau]="perfil.losigo == 'pendiente'"
              [class.borde-success]="perfil.losigo == 'activo'"
              width="100%"
              alt="Foto de perfil"
              [attr.data-full]="perfil?.foto?.foto_principal_grande"
              [attr.data-titulo]="perfil.first_name"
              [attr.data-texto1]="(perfil.sexo === 'Hombre' ? '<i class=\'fa-solid fa-mars\'></i>' : perfil.sexo === 'Mujer' ? '<i class=\'fa-solid fa-venus\'></i>' : '') + ' ' + perfil.sexo + ' de ' + perfil.edad"
              [attr.data-texto2]="perfil.ciudad ? '<i class=\'fa-regular fa-building\'></i> ' + perfil.ciudad + (perfil.pais ? ', ' + perfil.pais : '') : ''"
            />
            <!-- Botón papelera flotante -->
            <span *ngIf="editando" class="btn-delete" (click)="borrarFoto()">
              <i class="fa-solid fa-trash small" title="Borrar foto"></i>
            </span>
            <img *ngIf="editando"
              [src]="previewUrl ? previewUrl : perfil?.foto?.foto_principal_thumb" class="rounded-circle pointer borde-editable" width="100%" alt="Foto de perfil"
              (click)="onClickImagenPrincipal()">
          </div>
          <div class="col"> <!-- d-flex flex-column flex-grow-1-->
            <div class="iguau-profile-name-toolbar">
              <div class="iguau-profile-name-field">
                <app-inline-edit
                    [modoEditar]="editando"
                    [(ngModel)]="perfil.first_name"
                    inputClass="form-control fs-1">
                  <h1 class="perfil-nombre">{{ perfil.first_name || 'Escribe tu nombre' }}</h1>
                </app-inline-edit>
              </div>
              <div class="iguau-profile-edit-controls" *ngIf="perfil?.ID == misdatos?.ID" aria-label="Editar mis datos">
                <button *ngIf="!editando" class="iguau-edit-button" type="button" (click)="editarPerfil()" title="Editar perfil">
                  <i class="fa-solid fa-pen" aria-hidden="true"></i><span>Editar</span>
                </button>
                <ng-container *ngIf="editando">
                  <button class="iguau-save-button" type="button" (click)="editarPerfil()" title="Guardar perfil">
                    <i class="fa-solid fa-check" aria-hidden="true"></i><span>Grabar</span>
                  </button>
                  <button class="iguau-cancel-button" type="button" (click)="cancelarPerfil()" title="Cancelar edición">
                    <i class="fa-solid fa-xmark" aria-hidden="true"></i><span>Cancelar</span>
                  </button>
                </ng-container>
              </div>
            </div>
            <div class="mt-2">
              <app-inline-edit 
                  [modoEditar]="editando"
                  class="mi-app-flex text-nowrap"
                  type="select"
                  [options]="['Hombre', 'Mujer', 'Otro', 'Prefiero no decirlo']"
                  [(ngModel)]="perfil.sexo" 
                  inputClass="">
                <span *ngIf="perfil.sexo=='Hombre'"><i class="fa-solid fa-mars"></i></span>
                <span *ngIf="perfil.sexo=='Mujer'"><i class="fa-solid fa-venus"></i></span>
                <span *ngIf="perfil.sexo || editando" [class.text-secondary]="!perfil.sexo">{{perfil.sexo || 'Sexo'}}</span>
              </app-inline-edit>
              <span class="ms-2 me-2">·</span>
              <app-inline-edit 
                  [modoEditar]="editando"
                  class="mi-app-flex text-nowrap"
                  [(ngModel)]="perfil.fecha_nac" 
                  [type]="'date'"
                  inputClass="mi-app-flex form-control"
                  (ngModelChange)="calcularEdad()">
                <span *ngIf="perfil.edad || editando" [class.text-secondary]="!perfil.edad">{{perfil.edad || 'Edad'}}</span>
              </app-inline-edit>
              <span class="d-none d-md-inline" *ngIf="perfil.mascotas > 0 && !editando">
                <span class="ms-2 me-2">·</span>{{perfil.mascotas > 0 ? perfil.mascotas + ' mascota' + (perfil.mascotas > 1 ? 's' : '') : 'sin mascotas'}}
              </span>
              <div class="d-md-none" *ngIf="perfil.mascotas > 0 && !editando">
                {{perfil.mascotas > 0 ? perfil.mascotas + ' mascota' + (perfil.mascotas > 1 ? 's' : '') : 'sin mascotas'}}
              </div>
            </div>
            <div class="d-none d-xl-block">
              <div class="row mt-2" *ngIf="editando">
                <div class="col">
                  <div class="buscador-container">
                    <label for="direccionfisica" class="form-label">¿Dónde estás? Elige tu ubicación para ver perfiles cercanos. <i>Solo se mostrará tu zona general, nunca tu dirección exacta</i></label>
                    <div class="input-group mb-3">
                      <input 
                        type="text" 
                        class="form-control"
                        [formControl]="inputBuscador" 
                        [(ngModel)]="perfil.direccionfisica"
                        id="direccionfisica"
                        placeholder="Escribe una dirección, municipio o localidad (Ej: Calle Mayor, Madrid)..."
                        (focus)="mostrarDesplegable = true"
                      />
                      <ul class="desplegable" *ngIf="mostrarDesplegable && (sugerencias$ | async) as sugerencias">
                        <li *ngFor="let item of sugerencias" (click)="seleccionarDireccion(item)">
                          {{ item.display_name }}
                        </li>
                        <li *ngIf="sugerencias.length === 0 && inputBuscador.value!.length > 3" class="sin-resultados">
                          No se encontraron resultados
                        </li>
                      </ul>
                      <button class="btn btn-primary btn-input-group" type="button" id="button-addon2" (click)="permisoGeolocalizacion(false)">
                        <i class="fa-solid fa-location-dot"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <div class="d-flex">
                  <div class="me-2">
                    <i class="fa-solid fa-location-dot text-info"></i>
                  </div>
                  <div>
                    <span class="spinner-grow spinner-grow-sm text-iguau me-1" role="status" *ngIf="app.getgeo && (perfil.barrio == '' || perfil.ciudad == '')">
                      <span class="visually-hidden">Loading...</span>
                    </span>
                    {{ funciones.unirConComas(perfil.barrio, perfil. ciudad, perfil.provincia, perfil.pais ) }}
                    <div *ngIf="perfil.distancia && perfil.ID != misdatos.ID">
                      <span class="text-info fw-bold">{{perfil.distancia.distancia}} {{perfil.distancia.medida}}</span> de distancia de ti
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-xl-none">
          <div class="row mt-2" *ngIf="editando">
            <div class="col">
              <div class="buscador-container">
                <label for="direccionfisica-movil" class="form-label">¿Dónde estás? Elige tu ubicación para ver perfiles cercanos. <i>Solo se mostrará tu zona general, nunca tu dirección exacta</i></label>
                <div class="input-group mb-3">
                  <input 
                    type="text" 
                    class="form-control"
                    [formControl]="inputBuscador" 
                    [(ngModel)]="perfil.direccionfisica"
                    id="direccionfisica-movil"
                    placeholder="Escribe una dirección, municipio o localidad (Ej: Calle Mayor, Madrid)..."
                    (focus)="mostrarDesplegable = true"
                  />
                  <ul class="desplegable" *ngIf="mostrarDesplegable && (sugerencias$ | async) as sugerencias">
                    <li *ngFor="let item of sugerencias" (click)="seleccionarDireccion(item)">
                      {{ item.display_name }}
                    </li>
                    <li *ngIf="sugerencias.length === 0 && inputBuscador.value!.length > 3" class="sin-resultados">
                      No se encontraron resultados
                    </li>
                  </ul>
                  <button class="btn btn-primary btn-input-group" type="button" id="button-addon2" (click)="permisoGeolocalizacion(false)">
                    <i class="fa-solid fa-location-dot"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-2">
            <div class="d-flex">
              <div class="me-2">
                <i class="fa-solid fa-location-dot text-info"></i>
              </div>
              <div>
                <span class="spinner-grow spinner-grow-sm text-iguau me-1" role="status" *ngIf="app.getgeo && (perfil.barrio == '' || perfil.ciudad == '')">
                  <span class="visually-hidden">Loading...</span>
                </span>
                {{ funciones.unirConComas(perfil.barrio, perfil. ciudad, perfil.provincia, perfil.pais ) }}
                <div *ngIf="perfil.distancia && perfil.ID != misdatos.ID">
                  <span class="text-info fw-bold">{{perfil.distancia.distancia}} {{perfil.distancia.medida}}</span> de distancia de ti
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="perfil.cuenta_bloqueada == 1">
          <span class="badge bg-danger"><i class="fa-solid fa-ban me-1"></i> Cuenta bloqueada</span>
        </div>

        <div class="mt-3">
          <app-inline-edit 
              *ngIf="perfil.rol_perfil == 'social'"
              [modoEditar]="editando"
              [(ngModel)]="perfil.description" 
              inputClass="form-control"
              type="textarea">
            <app-leer-mas *ngIf="perfil.description || editando" 
              [class.text-secondary]="!perfil.description" 
              [texto]="perfil.description || 'Descríbete, cuenta algo de ti, presenta tu mundo animal, deja tu huella...'" 
              [limite]="300" class="pointer"></app-leer-mas>
          </app-inline-edit>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-4 mt-auto" *ngIf="perfil.rol_perfil == 'social'">
        <div class="social-panel iguau-health-notice iguau-alert-carousel mt-3" *ngIf="avisoPropio && avisos.length" aria-roledescription="carrusel" aria-label="Próximos cuidados y paseos">
          <div class="ig-alert-head">
            <span class="status-pill"><i class="fa-solid fa-bell" aria-hidden="true"></i> Tus próximos avisos</span>
            <span class="ig-alert-counter">{{ avisoActual + 1 }} / {{ avisos.length }}</span>
          </div>
          <div class="ig-alert-item" *ngIf="avisoVisible as aviso" aria-live="polite"
            [ngClass]="'ig-alert-' + getTipoCuidadoVisual(aviso)">
            <div class="ig-alert-content">
              <div class="ig-alert-title">{{ aviso.titulo }}</div>
              <div class="ig-alert-type">
                <i [class]="getIconoCuidado(aviso)" aria-hidden="true"></i>
                {{ aviso.tipo === 'salud' ? aviso.tipoCuidado : 'Paseo' }}
              </div>
              <div class="ig-alert-meta">
                <span class="ig-alert-date"><i class="fa-regular fa-calendar" aria-hidden="true"></i> {{ aviso.fecha | date:'d MMMM y' }}</span>
                <span class="ig-alert-time" *ngIf="aviso.hora"><i class="fa-regular fa-clock" aria-hidden="true"></i> {{ aviso.hora | slice:0:5 }}</span>
                <span class="ig-alert-repeat" *ngIf="aviso.periodicidad"><i class="fa-solid fa-repeat" aria-hidden="true"></i> {{ aviso.periodicidad }}</span>
                <span class="ig-alert-status" [class.is-late]="aviso.vencido"><i class="fa-solid fa-bell" aria-hidden="true"></i> {{ aviso.etiqueta }}</span>
              </div>
              <p class="ig-alert-desc" *ngIf="aviso.descripcion">{{ aviso.descripcion }}</p>
              <a class="ig-alert-link" [href]="aviso.enlace">{{ aviso.tipo === 'paseo' ? 'Ver paseos' : 'Ver salud' }} <i class="fa-solid fa-arrow-right" aria-hidden="true"></i></a>
            </div>
          </div>
          <div class="ig-alert-footer" *ngIf="avisos.length > 1">
            <button type="button" class="ig-alert-arrow" (click)="moverAviso(-1)" aria-label="Aviso anterior"><i class="fa-solid fa-chevron-left"></i></button>
            <div class="ig-alert-dots" aria-label="Seleccionar aviso">
              <button *ngFor="let aviso of avisos; let i = index" type="button" [class.active]="i === avisoActual" (click)="seleccionarAviso(i)" [attr.aria-label]="'Aviso ' + (i + 1)" [attr.aria-current]="i === avisoActual ? 'true' : null"></button>
            </div>
            <button type="button" class="ig-alert-arrow" (click)="moverAviso(1)" aria-label="Aviso siguiente"><i class="fa-solid fa-chevron-right"></i></button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg">
        <app-perfil-acciones [misdatos]="misdatos" [perfil]="perfil"></app-perfil-acciones>
      </div>
    </div>

    <div class="iguau-hero-admin" *ngIf="misdatos?.rol == 'administrator'">
      <app-perfil-admin [misdatos]="misdatos" [perfil]="perfil"></app-perfil-admin>
    </div>

  </div>
</div>

<input
  type="file"
  #fileInputPrincipal
  accept="image/*"
  style="display: none"
  (change)="onFileSelectedPrincipal($event)"
/>
